import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from './Button'
import Modal from './Modal'

type Props = {
  responseType: string
  onCancel: () => void
}

const feedbackIconClassNames = {
  promoter: 'text-sentiment-positive',
  passive: 'text-sentiment-neutral',
  detractor: 'text-sentiment-negative'
} as const

export default function FeedbackResponseModal ({ responseType, onCancel }: Props) {
  return (
    <Modal onClose={onCancel}>
      <div className='flex flex-col gap-4 items-center'>
        <p
          className='text-lg font-semibold w-full text-center'
        >
        Bedankt voor je feedback!
        </p>

        <div className='flex justify-between w-full'>
          <FontAwesomeIcon
            icon={['far', 'face-smile']}
            size='5x'
            className={`${feedbackIconClassNames.promoter} ${responseType === 'promoter' ? '' : 'opacity-50'}`}
          />

          <FontAwesomeIcon
            icon={['far', 'face-meh']}
            size='5x'
            className={`${feedbackIconClassNames.passive} ${responseType === 'passive' ? '' : 'opacity-50'}`}
          />

          <FontAwesomeIcon
            icon={['far', 'face-frown']}
            size='5x'
            className={`${feedbackIconClassNames.detractor} ${responseType === 'detractor' ? '' : 'opacity-50'}`}
          />
        </div>

        <p className='text-center text-text-primary'>
          {responseType !== 'promoter' && 'We waarderen het dat je de tijd hebt genomen om ons feedback te geven. Je mening helpt ons om onze applicatie te verbeteren en beter af te stemmen op je behoeften.'}

          {responseType === 'promoter' && 'Fijn dat je tevreden bent.'}
        </p>

        <Button
          onClick={onCancel}
          className='w-full'
        >
        Sluiten
        </Button>
      </div>
    </Modal>
  )
}
